import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PayPalTransactionItem } from './payments-data.data';
import {
  getLoadingPayPalTransactionHistory,
  getPayPalTransactionHistory,
  getPayPalTransactionHistoryNextPageTimestamp,
} from './payments-data.reducer';

@Injectable()
export class PaymentsDataStore {
  payPalTransactionHistory$: Observable<
    List<PayPalTransactionItem>
  > = this._store.select(getPayPalTransactionHistory);

  payPalTransactionHistoryNextPageTimestamp$: Observable<string> = this._store.select(
    getPayPalTransactionHistoryNextPageTimestamp
  );

  loadingPayPalTransactionHistory$: Observable<boolean> = this._store.select(
    getLoadingPayPalTransactionHistory
  );

  constructor(private _store: Store<any>) {}
}
